// Perfis e permissões, portados do access.js do mock.
// ⚠️ No front isto só decide o que MOSTRAR. Quem autoriza é o servidor (ver openapi/console.yaml).
import type { Me, Permission, Role } from "@/api/types";

export const ROLES: Role[] = [
  "Iuvo Admin",
  "Iuvo Ops/CS",
  "Gestor do cliente",
  "Operador do cliente",
  "Auditor do cliente",
];

export const PERMISSION_LABELS: Record<Permission, string> = {
  overview: "Visão geral",
  conversations: "Conversas e filas",
  quality: "Qualidade",
  surveys: "Pesquisas e respostas",
  alerts: "Alertas",
  reports: "Relatórios",
  templates: "Templates WhatsApp",
  knowledge: "Base de conhecimento",
  medical: "Auditoria de pareceres",
  agents: "Agentes",
  channels: "Canais",
  changes: "Solicitações de mudança",
  users: "Gerenciar usuários",
  export: "Exportar dados",
  reveal: "Revelar dados pessoais",
  costs: "Custos e consumo",
  publish: "Publicações",
  roadmap: "Roadmap",
};

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  "Iuvo Admin": Object.keys(PERMISSION_LABELS) as Permission[],
  "Iuvo Ops/CS": [
    "overview", "conversations", "quality", "surveys", "alerts", "reports", "templates",
    "knowledge", "medical", "agents", "channels", "changes", "export", "roadmap",
  ],
  "Gestor do cliente": [
    "overview", "conversations", "quality", "surveys", "alerts", "reports", "templates",
    "knowledge", "medical", "agents", "channels", "changes", "users", "export", "roadmap",
  ],
  "Operador do cliente": ["conversations", "alerts", "templates"],
  "Auditor do cliente": ["overview", "medical", "reports", "export"],
};

export const isInternal = (me: Pick<Me, "role">) => me.role.startsWith("Iuvo");
export const isAdmin = (me: Pick<Me, "role">) => me.role === "Iuvo Admin";
export const isManager = (me: Pick<Me, "role">) => isAdmin(me) || me.role === "Gestor do cliente";
export const can = (me: Pick<Me, "permissions">, p: Permission) => me.permissions.includes(p);

/** Regras de visibilidade de tela que não cabem numa permissão só (allowed() do mock). */
export type AccessRule = "internal" | "admin" | "medical" | "users";

export function passesRule(me: Me, rule: AccessRule | undefined): boolean {
  switch (rule) {
    case undefined:
      return true;
    case "internal":
      return isInternal(me);
    case "admin":
      return isAdmin(me);
    case "medical":
      return isInternal(me) || me.role === "Gestor do cliente" || me.role === "Auditor do cliente";
    case "users":
      return can(me, "users") || isAdmin(me);
  }
}
